import { render, staticRenderFns } from "./SharedFile.vue?vue&type=template&id=5e80ed36&"
import script from "./SharedFile.vue?vue&type=script&lang=js&"
export * from "./SharedFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports